<template>
  <div  v-loading='loading' class="material">
    <div class="form">
         <el-form :model="formData">
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item>
                        <ESelect
                            v-model="formData.config"
                            placeholder="请选择"
                            style="width:100%"
                        >
                            <el-option
                                v-for="item in fileConfigList"
                                :key="item.id"
                                :value-key="item.id"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-input
                        placeholder="请输入素材或项目名称搜索"
                        v-model="formData.keyWords"
                        style="width: 100%"
                        @keyup.enter.native="()=>refreshList()"
                    >
                        <el-button slot="append" icon="el-icon-search" @click="()=>refreshList()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="6">
                    <el-form-item>
                        <ESelect v-model="formData.state" placeholder="素材状态"  clearable>
                            <el-option
                                v-for="item in ideaGlobal.searchConfigData.material_status_map"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="11">
                    <ESelect
                        v-model="formData.workId"
                        style="width: 100%"
                        multiple
                        filterable
                        remote
                        collapse-tags
                        reserve-keyword
                        clearable
                        placeholder="工单：请输入工单ID或名称搜索"
                        :remote-method="handleRemoteMethod"
                        ref="select"
                        :loading="remoteLoading">
                        <p class="option-select">
                            <el-button type="text" @click="handleCheckAll">全选</el-button>
                            <el-button type="text" @click="()=>formData.workId=[]">取消全选</el-button>
                        </p>
                        <el-option
                            v-for="item in workList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </ESelect>
                </el-col>
                <el-col :span="10">
                     <el-form-item>
                        <ESelect style="width: 100%" v-model="formData.plat_id" multiple clearable collapse-tags placeholder="素材渠道" filterable>
                            <el-option
                                v-for="item in ideaGlobal.searchConfigData.plat_map"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                </el-col>
                <el-col :span="3" class="tar">
                    <el-dropdown placement="bottom" ref="dropdownRef" @command="handleOptCommand" :hide-on-click="false">
                        <el-button  type="primary" plain >操作</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="all" >
                                <div class="opt-item">本页全部添加</div>
                            </el-dropdown-item>
                             <el-dropdown-item  divided>
                                    
                                <div class="opt-item">
                                    <div class="label">
                                        <p>添加本页</p>
                                        <p>前N个素材</p>
                                    </div>
                                    <el-input 
                                        v-model.number="formData.pageN" 
                                        class="mr8 ml8" style="width:50px" size="mini" 
                                        @input="(value)=>formData.pageN=value.replace(/[^0-9]|^0$/g,'')"
                                    /> 
                                    <i 
                                        class="icon text-color-success" 
                                        @click="handleAddMaterial('pageN')"
                                        :class="addLoading?'el-icon-loading':'el-icon-success'"
                                    />
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item  divided>
                                <div class="opt-item">
                                    <div class="label">
                                        添加前N个
                                    </div>
                                    <el-input 
                                        v-model.number="formData.firstN" 
                                        class="mr8 ml8" style="width:50px" size="mini" 
                                        @input="(value)=>formData.firstN=value.replace(/[^0-9]|^0$/g,'')"
                                    /> 
                                    <i 
                                        class="icon text-color-success" 
                                        @click="handleAddMaterial('firstN')"
                                        :class="addLoading?'el-icon-loading':'el-icon-success'"
                                    />
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item  divided>
                                <div class="opt-item">
                                    <div class="label">
                                        <p>添加前N个</p>
                                        <p>未使用素材</p>
                                    </div>
                                    <el-input 
                                        v-model.number="formData.noUseFirstN" 
                                        class="mr8 ml8" style="width:50px" size="mini"
                                        @input="(value)=>formData.noUseFirstN=value.replace(/[^0-9]|^0$/g,'')"
                                     /> 
                                    <i 
                                        class="icon text-color-success" 
                                        @click="handleAddMaterial('noUseFirstN')"
                                        :class="addLoading?'el-icon-loading':'el-icon-success'"
                                    />
                                </div>
                            </el-dropdown-item>
                             <el-dropdown-item  divided>
                                <div class="opt-item">
                                    <div class="label">
                                        <p style="font-size:12px;">添加前N个vivo</p>
                                        <p style="font-size:12px;">已使用无消耗素材</p>
                                    </div>
                                    <el-input 
                                        v-model.number="formData.usedWithoutCostFirstN" 
                                        class="mr8 ml8" style="width:50px" size="mini"
                                        @input="(value)=>formData.usedWithoutCostFirstN=value.replace(/[^0-9]|^0$/g,'')"
                                     /> 
                                    <i 
                                        class="icon text-color-success" 
                                        @click="handleAddMaterial('usedWithoutCostFirstN')"
                                        :class="addLoading?'el-icon-loading':'el-icon-success'"
                                    />
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
        </el-form>
    </div>
    <div class="content mt20" :id="contentId">
        <template v-if="list.length">
            <div class="list" >
                <template v-for="item in list">
                    <div class="list-item" :key="item.id">
                        <WorkOrder :params="item" @add="()=>addItem(item, 'select', configData)"/>
                    </div>
                </template>
            </div>
            <el-pagination
                class="tal"
                layout="prev, pager, next"
                :current-page.sync="pageNum"
                :page-size="pageSize"
                @current-change="()=>getList()"
                :total="total">
            </el-pagination>
        </template>
        <div v-else class="no_data">暂无数据</div>
    </div>
  </div>
</template>

<script>
import API from '@/api/marketManage/vivoBatch';
import util from '@/libs/utils'
import WorkOrder from '../../workOrder.vue'
import { Select } from '@/views/mixins/ele'
import { throttle } from 'lodash';
import axios from 'axios';
const cancelList =[];
export default {
    name: 'Material',
    props: [ 'fileConfigList', 'hasAll' ],
    components: { WorkOrder },
    inject: [ 'addItem', 'showPage', 'keyWords', 'getAppList' , 'ideaGlobal'],
    mixins: [ Select({  ref: 'select', list: 'workList' })],
    data() {
        const keyWords = this.keyWords
        return {
            remoteLoading: false,
            formData: {
                config: 'all',
                keyWords,
                workId: [],
                firstN: '',
                noUseFirstN: '',
                usedWithoutCostFirstN: '',
                pageN: '',
                plat_id: [],
                state: ''
            },
            workList: [],//工单列表,
            list: [],//工单素材
            loading: false,
            pageNum: 1,//当前页
            pageSize: 16,
            total: 0,
            contentId: `_${util.randomString(20)}`,
            cancel: [],//取消请求的函数
            addLoading: false,
        }
    },
    computed: {
        searchParams() {
            const { config, workId , plat_id, state } = this.formData;
            return {
                 config, workId, plat_id, state
            }
        },
        configData() {
            const { config } = this.formData;
            return  this.fileConfigList.find(v=> v.value === config) || {};
        }
    },
    mounted() {
        if (this.hasAll) {
            this.refreshList()
        }
        const fn =  (name)=> {
             console.log(222);
            let res_name = name.split('-')
            this.formData.keyWords = res_name && res_name.length > 0 ? res_name[0] : '';
            this.refreshList()
        };
        const listFn = () =>{
          this.$nextTick(()=> {
            this.formData.config =  this.fileConfigList[0].value;
          })
            // this.refreshList()
        };
        const configFn = ()=> {
            this.formData.config = ''
        }
        this.$bus.$on('updateListData',listFn);
        this.$bus.$on('delconfigData',configFn);
        this.$bus.$on('updateAppData',fn);
        this.$once('hook:beforeDestroy', () => {
            this.$bus.$off('updateListData', listFn)
            this.$bus.$off('updateAppData', fn)
            this.$bus.$off('delconfigData', configFn)
        });
    },
    methods: {
        handleOptCommand(type) {
            if (this.addLoading) {
                return
            }
            if (type === 'all') {
                this.$refs.dropdownRef.hide();
                this.addPageData()
            }
        },
        async handleAddMaterial(type) {
            if (this.addLoading) {
                return
            }
            this.addLoading = true
            try {
                const p =this.getConfigParams();
                const params = { ...p };
                const num = this.formData[type];
                if (!num) {
                    return this.$message.error('请输入添加数量');
                }else {
                    if(+num> 1000) {
                        return this.$message.error('添加数量不能超过1000');
                    }
                }
                if ('firstN' === type) {
                    params.num = num;
                    // noUseFirstN
                }else if ('noUseFirstN' === type) {
                    params.not_use_num = num;
                }else if('pageN' === type) {
                    this.$refs.dropdownRef.hide();
                    this.addPageData(num);
                    this.formData[type] = '';
                    return
                } else {
                     params.used_without_cost_num = num;
                }
                const { data } = await API.getWorkOrderMaterialByNum(params);
                data.map(item=> {
                    this.addItem(item, 'select', this.configData)
                });
                if(!data || data.length ===0) {
                    return this.$message.error('无可添加的素材')
                };
                this.formData[type] = '';
               
                if (data.length < num) {
                    this.$message.error(`素材数量不足【${num}】，已将满足要求的素材全部添加`)
                }
               
            } catch (error) {
                console.log(error, '添加失败');
                this.$message.error(error.info || error.message)
            }finally {
                this.addLoading = false
            }
        },
        updataPageSize() {
            try {
                const dom = document.querySelector(`#${this.contentId}`);
                const num = Math.floor( dom.clientWidth/156);
                this.pageSize = (num <=4 ? 4 : num) *4;
            } catch (error) {
                console.log('数量计算错误', error);
            }
        },
        handleConfigChange() {
            this.formData.workId = []
            this.workList = []
        },
        // 添加全部数据
        addPageData(num) {
            if (!this.list.length) {
                this.$message.error('无可添加的数据')
                return
            }
            if (num) {
                [...this.list].splice(0, num).map(item=> {
                    this.addItem(item, 'select', this.configData)
                })
            }else {
                this.list.map(item=> {
                    this.addItem(item, 'select', this.configData)
                })
            }
           
        },
        handleCheckAll() {
            const ids = this.formData.workId;
            this.workList.map(v=>v.value);
            this.formData.workId = [
                ...new Set([
                    ...ids,
                    ...this.workList.map(v=>v.value)
                ])
            ]
        },
        refreshList() {
            if (this.showPage&&!this.showPage()) {
                return
            }
            this.pageNum = 1;
            this.getList()
        },
        // 列表
        getList: throttle(async function (){
            this.list = [];
            let cancel = null;
            while(cancel = cancelList.shift()) {
                cancel&&cancel()
            };
            let cancelFn = null;
            try {
                const { config, keyWords, workId } = this.formData;
                if (!config) {
                    return;
                }
                const p =this.getConfigParams();
                if (!(p.conf&&p.conf.length)) {
                   return;
                }
                const appList = this.getAppList();
                const params = {
                    search: keyWords,
                    order_id: workId,
                    package_name: appList.map(v=>v._package_name),
                    ...p,
                    pn: this.pageNum,
                    rn: this.pageSize
                };
                this.loading = true
                const { data } = await API.getWorkOrderMaterialList(params, {
                     cancelToken: new axios.CancelToken( (c)=> {
                       cancelList.push(cancelFn = c)
                    }),
                });
                this.list = data.list;
                this.total = data.totalCnt;
            } catch (error) {
                console.log(error);
                // this.$message.error(error.info) 不需要弹出吧
            }finally {
                const index = cancelList.indexOf(cancelFn);
                if (index> -1) {
                    cancelList.splice(index, 1);
                }
                this.loading = false
            }
        }, 500),
        // 搜索
        async handleRemoteMethod(search) {
            try {
                this.remoteLoading = true;
                 const { config } = this.formData;
                const p =this.getConfigParams();
                const appList = this.getAppList();
                const params = {
                    package_name: appList.map(v=>v._package_name),
                    ...p,
                    search
                }
               const { data } =  await API.getVivoWorkOrderList(params);
                this.workList = data.map(v=> {
                    return {
                        ...v,
                        value: v.id,
                        label: `工单：${v.work_order_name}(${v.id})`
                    }
                })
            } catch (error) {
                this.$message.error(error.info)
            } finally {
                this.remoteLoading = false
            }
        },
        getConfigParams() {
             const { config } = this.formData;
             const conf = [];
            if (config === 'all') {
                this.fileConfigList.forEach(v=> {
                    if (v.value !== 'all') {
                        conf.push( this.getParams(v))
                    }
                })
            }else {
                const configData = this.fileConfigList.find(v=> v.value === config);
                conf.push( this.getParams(configData))
            }
            const {  keyWords, workId, plat_id , state } = this.formData;
            const appList = this.getAppList();
            return { 
                conf,
                search: keyWords,
                order_id: workId,
                plat_id,
                is_used: state,
                package_name: appList.map(v=>v._package_name),
            }
        },
        getParams(configData) {
            const {
                material_type, conf_format, conf_length,
                conf_size, conf_resolution
            } = configData;
           return {
                    conf_length: conf_length? `0-${conf_length/1000}` : null,
                    conf_format,conf_size, conf_resolution,
                    config_type: material_type,
                }
        }
    },
    watch: {
        fileConfigList(n) {
            if (n&&n.length) {
                this.formData.config = n[0].value;
            }
        },
        'formData.config'() {
            this.handleConfigChange()
        },
        searchParams: {
            handler() {
                this.updataPageSize()
                 this.refreshList()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.opt-item {
    padding: 6px 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .label {
        width: 100px;
        p {
            line-height: 1;
        }
    }
    .icon {
        font-size: 20px;
    }
}
.form-btn {
    text-align: right;
}
.no_data {
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
}
.list {
    display: flex;
    flex-wrap: wrap;
}
.material {
    height: 100%;
    display: flex;
    flex-direction: column;
    .form {
        height: 90px;
    }
    .content {
        flex: 1;
        height: 0;
        overflow: auto;
    }
}
</style>
